import type { CreditInfo } from '@/lib/api'
import { useCreditInfo } from '@/lib/hooks'

/**
 * Cents one credit is worth for this client: `creditInfo.creditDisplayValueCents` of the profile
 * (set in the backoffice). Null when missing or not a positive number: a surface then shows
 * credits only, never a guessed dollar amount.
 */
export function creditRateCentsFromInfo(
  info: Pick<CreditInfo, 'creditDisplayValueCents'> | null | undefined,
): number | null {
  const value = info?.creditDisplayValueCents
  return typeof value === 'number' && Number.isFinite(value) && value > 0 ? value : null
}

/**
 * The signed-in account's credit value in cents per credit, for dollar figures on pricing
 * surfaces that do not hold the profile themselves. Null while disabled, until the profile
 * is loaded, or when the value is unusable.
 */
export function useCreditRateCents(isEnabled: boolean): number | null {
  const { data } = useCreditInfo()
  return isEnabled ? creditRateCentsFromInfo(data) : null
}
